import { AutogenLayoutPerfAlertDefList } from "./autogen/AutogenLayoutPerfAlertDefList";
import { DataDisplayEvent, Label } from "@mcleod/components";

export class PerfAlertDefList extends AutogenLayoutPerfAlertDefList {

    /** This is an event handler for the onDataDisplay event of textboxcomp_operand54. */
    textboxcomp_operand54OnDataDisplay(event: DataDisplayEvent) {
        const label = event.target as Label;

        if (label.text === "G")
            label.setProps({ text: "greater than" });
        else if (label.text === "L")
            label.setProps({ text: "less than" });

    }

    /** This is an event handler for the onDataDisplay event of textboxvalue1_period51. */
    textboxvalue1_period51OnDataDisplay(event: DataDisplayEvent) {

        const label = event.target as Label;

        if (label.text === "S")
            label.setProps({ text: "single value" });
    }


    /** This is an event handler for the onDataDisplay event of textboxvalue2_period60. */
    textboxvalue2_period60OnDataDisplay(event: DataDisplayEvent) {

        const label = event.target as Label;

        if (label.text === "SV")
            label.setProps({ text: "specified value" });
    }
}
